import { render, staticRenderFns } from "./404.vue?vue&type=template&id=448aefbf&scoped=true"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"
import style0 from "./404.vue?vue&type=style&index=0&id=448aefbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448aefbf",
  null
  
)

export default component.exports